import classNames from "classnames";
import React from "react";
import Tick from "../../../../../assets/svgs/Tick.svg";
import { JobSearchFilterItem } from "../../JobSearchFilterAndResults.blok";

interface JobSearchFilterSectionItemProps {
  filter_item: JobSearchFilterItem;
  filterGroupName: string;
  selectedFilters: string[];
  updateSelectedFilters: (newFilters: string[]) => void;
}

const JobSearchFilterSectionItem: React.FC<JobSearchFilterSectionItemProps> = ({
  filter_item,
  filterGroupName,
  selectedFilters,
  updateSelectedFilters,
}) => {
  const filterIdentifier = `${filterGroupName}:${filter_item.name}`;

  const isFilterItemSelected = () => {
    return selectedFilters.includes(filterIdentifier);
  };

  const checkboxButtonClassNames = classNames(
    "border-2 border-Secondary-300 rounded-sm w-3.5 h-3.5 p-[1px] flex items-center justify-center",
    {
      "bg-Secondary-300": isFilterItemSelected(),
    },
  );

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center justify-start">
        <p className="text-Body">{filter_item.name}</p>
      </div>
      <button
        className={checkboxButtonClassNames}
        onClick={() => {
          const newFiltersArray = isFilterItemSelected()
            ? selectedFilters.filter(filter => filter !== filterIdentifier)
            : [...selectedFilters, filterIdentifier];

          updateSelectedFilters(newFiltersArray);
        }}
        aria-label="Update filter"
      >
        {isFilterItemSelected() && <Tick className="fill-White" />}
      </button>
    </div>
  );
};

export default JobSearchFilterSectionItem;
